import { DecisionReason } from "../../../../../../model/model"
import EvaluateRequest from "../../../../../EvaluateRequest"
import { EvaluatorContext } from "../../../../../evaluator/Evaluator"
import EvaluationEventRecorder from "../../../../../event/EvaluationEventRecorder"
import LocalEvaluator from "../../../../../mode/local/LocalEvaluator"
import { InAppMessageEligibilityEvaluateResult } from "../../InAppMessageEligibilityEvaluateResult"
import { InAppMessageEligibilityEvaluateResponse } from "../../InAppMessageEligibilityEvaluateResponse"
import { InAppMessageEligibilityLocalEvaluateRequest } from "./InAppMessageEligibilityLocalEvaluateRequest"
import InAppMessageEligibilityLocalEvaluationFlowFactory from "../../flow/InAppMessageEligibilityLocalEvaluationFlowFactory"
import InAppMessageEligibilityEvaluator from "../../InAppMessageEligibilityEvaluator"

export class InAppMessageEligibilityLocalEvaluator
  extends LocalEvaluator<InAppMessageEligibilityLocalEvaluateRequest, InAppMessageEligibilityEvaluateResponse>
  implements InAppMessageEligibilityEvaluator<InAppMessageEligibilityLocalEvaluateRequest>
{
  constructor(
    private readonly evaluationFlowFactory: InAppMessageEligibilityLocalEvaluationFlowFactory,
    private readonly eventRecorder: EvaluationEventRecorder
  ) {
    super()
  }

  /**
   * @override
   */
  supports(request: EvaluateRequest): request is InAppMessageEligibilityLocalEvaluateRequest {
    return request instanceof InAppMessageEligibilityLocalEvaluateRequest
  }

  /**
   * @override
   */
  protected doEvaluate(
    request: InAppMessageEligibilityLocalEvaluateRequest,
    context: EvaluatorContext
  ): InAppMessageEligibilityEvaluateResponse {
    const evaluationFlow = this.evaluationFlowFactory.get(request)
    const result =
      evaluationFlow.evaluate(request, context) ??
      InAppMessageEligibilityEvaluateResult.ineligible(DecisionReason.NOT_IN_IN_APP_MESSAGE_TARGET)
    return InAppMessageEligibilityEvaluateResponse.of(request, context, result)
  }

  /**
   * @override
   */
  record(_request: InAppMessageEligibilityLocalEvaluateRequest, response: InAppMessageEligibilityEvaluateResponse): void {
    this.eventRecorder.record(response)

    // evaluation which is ineligible with nonnullable layout evaluation means that message is deduplicated or hidden.
    // for preventing imbalance, we should record layout evaluation tracking exposure event.
    if (!response.evaluation.isEligible && response.layout !== null) {
      this.eventRecorder.record(response.layout)
    }
  }
}
